import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as Moment from 'moment';
import { isEmpty } from 'lodash';
import TableRow from '@material-ui/core/TableRow';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Tag from 'components/forms/Tag';
import TableCell from 'components/tables/tableCell';
import ErrorTooltip from 'components/tooltips/ErrorTooltip';
import { NYLAS_ERROR_MESSAGES } from 'constants/errors';
import { EMAIL_CONFIG_TYPES_LABELS } from 'constants/accountEmail';
import EmailConfigPopoverActions from './EmailConfigPopoverActions';

const getEmailConfigTypeLabel = accessType => (
  !isEmpty(EMAIL_CONFIG_TYPES_LABELS[accessType]) ? EMAIL_CONFIG_TYPES_LABELS[accessType] : 'N/A'
);

class EmailConfigRow extends Component {
  constructor() {
    super();
    this.state = {
      anchorEl: null,
    };
  }

  handleDotsClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleDotsClose = () => {
    this.setState({ anchorEl: null });
  }

  render() {
    const {
      emailConfig,
      changeIsPrimary,
      totalEmailConfigs,
      totalDefaultEmailConfigs,
    } = this.props;
    return (
      <TableRow key={emailConfig.id}>
        <TableCell>
          {NYLAS_ERROR_MESSAGES[emailConfig.error_type] ?
            <ErrorTooltip title={
              <><ErrorOutlineIcon /> {NYLAS_ERROR_MESSAGES[emailConfig.error_type]}</>
            }
            >
              <FiberManualRecordOutlinedIcon fontSize="small" className="inactive-color" />
            </ErrorTooltip> :
            <FiberManualRecordIcon fontSize="small" className="active-color" />
          }
        </TableCell>
        <TableCell>
          {emailConfig.sender_name} <strong>{`<${emailConfig.email}>`}</strong>
        </TableCell>
        <TableCell>{getEmailConfigTypeLabel(emailConfig.access_type)}</TableCell>
        <TableCell>{emailConfig.total_number_of_emails_per_day}</TableCell>
        <TableCell>{emailConfig.delay_between_each_email_sent}</TableCell>
        <TableCell>{Moment(emailConfig.created_date).format('MM/DD/YYYY')}</TableCell>
        <TableCell>{emailConfig.is_primary ? <Tag color="primary" label="Is default" /> : ''}</TableCell>
        <TableCell>
          <EmailConfigPopoverActions
            emailConfig={emailConfig}
            anchorEl={this.state.anchorEl}
            accountId={this.props.account.id}
            organizationId={this.props.account.organization}
            handleDotsClick={this.handleDotsClick}
            handleDotsClose={this.handleDotsClose}
            changeIsPrimary={changeIsPrimary}
            showNotification={this.props.showNotification}
            totalEmailConfigs={totalEmailConfigs}
            totalDefaultEmailConfigs={totalDefaultEmailConfigs}
          />
        </TableCell>
      </TableRow>
    );
  }
}

EmailConfigRow.propTypes = {
  emailConfig: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.number,
    organization: PropTypes.number,
  }).isRequired,
  changeIsPrimary: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  totalEmailConfigs: PropTypes.number.isRequired,
  totalDefaultEmailConfigs: PropTypes.number.isRequired,
};

export default compose(connect(state => ({
  account: state.account,
}), { }))(EmailConfigRow);
